import { Radio, RadioGroup } from '@trackman/web-shared-components';

import { AppButton } from 'components/form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type RadioFilterProps = {
  filter: { options: any[]; type: string; selectProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const RadioFilter = ({ filter, onApply }: RadioFilterProps) => {
  const [value, setValue] = useState<string | number | undefined>();
  const { t } = useTranslation();

  return (
    <div className='data-table-filter-content gap-10px'>
      <RadioGroup
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        value={value}
      >
        {filter.options.map((c, i) => (
          <Radio data-test={`radio-${c.label?.replace(/\s/g, '')}`} key={i} {...c} checked={c.value === value} margin='3px' />
        ))}
      </RadioGroup>

      <AppButton data-test='ApplyFilterSubmit' type='button' className='apply-button ' variant='primary' onClick={() => onApply(value)}>
        {t('apply')}
      </AppButton>
    </div>
  );
};

export default RadioFilter;
